// extracted by mini-css-extract-plugin
export default {"container":"Invitations_container__1ABcX"};